import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import { Tabs, Pane } from '../../shared/tabs';

import MainForm from '../components/form/main';
import CredentialsForm from '../components/form/credentials';
import FeatureFlagsForm from '../components/form/feature-flags';
import { selectors as rootSelectors } from '../../root';

const Main = renderViewsState(props => {
	return (
		<Animate>
			<div className="container__content affiliates-edit">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Link to='affiliates/' className="link">{ props.intl('Return to list of affiliates') }</Link>
						<span>|</span>
						<Link to={`affiliates/profile/${props.data.id}`} className="link without-arrow">
							{props.intl('Return to affiliate profile')}
						</Link>
					</div>
					<div className="container__content-title-position">
						<h1 className="title">{ props.intl('Edit affiliate') }</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="form-container">
						<div className="form-container__head">
							<h2 className="title icon-edit">{ props.intl('Edit affiliate') }</h2>
							{ props.data.email && (
								<span className="item-title">{props.data.email}</span>
							)}
						</div>
						<Tabs selected={props.currentTab} onTabChange={props.changeTab}>
							<Pane label={ props.intl('Main') } index="main">
								<MainForm {...props} initialValues={props.formData.initialValues} enableReinitialize={true} />
							</Pane>
							<Pane label={ props.intl('Password') } index="credentials" isVisible={!!props.data.id}>
								<CredentialsForm {...props} />
							</Pane>
							<Pane
								label={ props.intl('Feature flags') }
								index="feature_flags"
								isVisible={!!props.data.id && props.can('edit_feature_flags')}
							>
								<FeatureFlagsForm {...props} initialValues={props.featureFlagsInitialData} />
							</Pane>
						</Tabs>
					</div>
				</div>
			</div>
		</Animate>
	);
}, 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		canEditFeatureFlagsManually: selectors.getCanEditFeatureFlagsManually(state),
		intl: selectors.getIntl(state),
		isNewLeadSource: selectors.getIsNewLeadSource(state),
		can: selectors.getCan(state),
		progressBar: selectors.getProgressBar(state),
		featureFlagsInitialData: selectors.getFeatureFlagsInitialData(state),
		currentTab: selectors.getCurrentTab(state),
		formData: selectors.getFormData(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/edit/main.js